import React, { useState } from "react";
import { cn } from "@/lib/utils";

interface ImageHoverPopupProps {
  children: React.ReactNode;
  imageSrc: string;
  imageAlt: string;
  className?: string;
}

const ImageHoverPopup = ({ children, imageSrc, imageAlt, className }: ImageHoverPopupProps) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div 
      className={cn("relative inline-block", className)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}
      
      {isHovered && (
        <div className="fixed inset-0 z-50 flex items-center justify-center pointer-events-none">
          <div className="absolute inset-0 bg-black/50" />
          <div className="relative z-10 animate-scale-in">
            <img
              src={imageSrc}
              alt={imageAlt}
              className="max-w-[90vw] max-h-[90vh] object-contain rounded-lg shadow-2xl"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageHoverPopup;